import { styled } from "styled-components";

const ContentBox = styled.pre`
  max-height: 400px;
  overflow-y: scroll;
  font-size: 20px;
  color: #878787;
  padding: 0 23px;
  margin: 0;
  line-height: 2.8rem;
  white-space: pre-wrap;
`;

export default ContentBox;
